import React, { useState, useEffect } from 'react';
import ScrollContext from './scrollContext';

const ScrollState = (props) => {
    const [visible, setVisible] = useState(true);
    const [prevScrollPos, setPrevScrollPos] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [prevScrollPos]);

    return (
        <ScrollContext.Provider value={{ visible }}>
            {props.children}
        </ScrollContext.Provider>
    );
};

export default ScrollState;
